import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createClient } from './createClient.js';
import { walletActions } from './decorators/wallet.js';
export function createWalletClient(parameters) {
  const {
    key = 'wallet',
    name = 'Wallet Client',
    transport
  } = parameters;
  const client = createClient(_objectSpread(_objectSpread({}, parameters), {}, {
    key,
    name,
    transport: opts => transport(_objectSpread(_objectSpread({}, opts), {}, {
      retryCount: 0
    })),
    type: 'walletClient'
  }));
  return client.extend(walletActions);
}
//# sourceMappingURL=createWalletClient.js.map